var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMcp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st2{fill:#53ADF8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62,10H28c-9.9,0-18,8.1-18,18v34c0,9.9,8.1,18,18,18h34c9.9,0,18-8.1,18-18V28C80,18.1,71.9,10,62,10z M74,62 c0,6.6-5.4,12-12,12H28c-6.6,0-12-5.4-12-12V28c0-6.6,5.4-12,12-12h34c6.6,0,12,5.4,12,12V62z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 2,
    y: 28,
    width: 14,
    height: 6,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 2,
    y: 44,
    width: 14,
    height: 6,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 2,
    y: 56,
    width: 14,
    height: 6,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 74,
    y: 28,
    width: 14,
    height: 6,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 74,
    y: 44,
    width: 14,
    height: 6,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 74,
    y: 56,
    width: 14,
    height: 6,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 28,
    y: 2,
    width: 6,
    height: 14,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 42,
    y: 2,
    width: 6,
    height: 14,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 56,
    y: 2,
    width: 6,
    height: 14,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 28,
    y: 74,
    width: 6,
    height: 14,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 42,
    y: 74,
    width: 6,
    height: 14,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 56,
    y: 74,
    width: 6,
    height: 14,
    rx: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 45,
    cy: 45,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45,33c-1.7,0-3,1.3-3,3v4c0,1.7,1.3,3,3,3s3-1.3,3-3v-4C48,34.3,46.7,33,45,33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45,47c-1.7,0-3,1.3-3,3v4c0,1.7,1.3,3,3,3s3-1.3,3-3v-4C48,48.3,46.7,47,45,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33,42h4c1.7,0,3,1.3,3,3s-1.3,3-3,3h-4c-1.7,0-3-1.3-3-3S31.3,42,33,42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50,42h4c1.7,0,3,1.3,3,3s-1.3,3-3,3h-4c-1.7,0-3-1.3-3-3S48.3,42,50,42z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcp);
export default __webpack_public_path__ + "static/media/MCP.ea2472b97caae12274fcc1c9436cd11f.svg";
export { ForwardRef as ReactComponent };